"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardKeyComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<button type="button" class="kbc-button${x => x.small ? ' kbc-button-small' : ''}${x => x.noclick ? ' no-click' : ''}"><slot></slot></button>`;
require("./styles/layout.scss");
const styles = T.css `.kbc-button {
  font-size: inherit;
  line-height: inherit;
  margin: 0.25rem 0.25rem 0.4375rem;
  padding: 0.1rem 0.4rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #fff;
  color: #343a40;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border: 1px solid #e6e6e6;
  border-radius: 0.25rem;
  display: inline-block;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
  font-weight: 400;
  text-align: left;
  transform: translateZ(5px);
  transform-style: preserve-3d;
  transition: all 0.25s cubic-bezier(0.2, 1, 0.2, 1);
}

.kbc-button:after {
  border-radius: 0.5rem;
  border-width: 0.125rem;
  bottom: -9px;
  left: -0.3125rem;
  right: -0.3125rem;
  top: -3px;
  transform: translateZ(-3px);
  border-color: #ccc;
}

.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 0 5px #4da3ff, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

.kbc-button-primary:after {
  border-color: #66b0ff;
}

.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 0 5px #939ba2, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 0 5px #48d368, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

.kbc-button-success:after {
  border-color: #5dd879;
}

.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 0 5px #36cee6, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

.kbc-button-info:after {
  border-color: #4cd3e9;
}

.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 0 5px #ba8b00, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

.kbc-button-warning:after {
  border-color: #a07800;
}

.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 0 5px #e77681, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

.kbc-button-danger:after {
  border-color: #eb8c95;
}

.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 0 5px #cbd3da, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

.kbc-button-light:after {
  border-color: #bdc6d0;
}

.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 0 5px #56606a, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

.kbc-button-dark:after {
  border-color: #626d78;
}

.kbc-button-xxs {
  font-size: 0.7rem;
  line-height: 1.5;
  margin: 0.25rem 0.25rem 0.375rem;
  padding: 0.1rem 0.3rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

.kbc-button-xxs:after {
  border-radius: 0.375rem;
  border-width: 0.0625rem;
  bottom: -6px;
  left: -0.25rem;
  right: -0.25rem;
  top: -2px;
  transform: translateZ(-2px);
  border-color: #ccc;
}

.kbc-button-xxs.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-primary:after {
  border-color: #66b0ff;
}

.kbc-button-xxs.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

.kbc-button-xxs.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-success:after {
  border-color: #5dd879;
}

.kbc-button-xxs.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-info:after {
  border-color: #4cd3e9;
}

.kbc-button-xxs.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

.kbc-button-xxs.kbc-button-warning:after {
  border-color: #a07800;
}

.kbc-button-xxs.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-danger:after {
  border-color: #eb8c95;
}

.kbc-button-xxs.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

.kbc-button-xxs.kbc-button-light:after {
  border-color: #bdc6d0;
}

.kbc-button-xxs.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

.kbc-button-xxs.kbc-button-dark:after {
  border-color: #626d78;
}

.kbc-button-xs {
  font-size: 0.725rem;
  line-height: 1.5;
  margin: 0.25rem 0.25rem 0.375rem;
  padding: 0.175rem 0.5rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

.kbc-button-xs:after {
  border-radius: 0.375rem;
  border-width: 0.0625rem;
  bottom: -6px;
  left: -0.25rem;
  right: -0.25rem;
  top: -2px;
  transform: translateZ(-2px);
  border-color: #ccc;
}

.kbc-button-xs.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-primary:after {
  border-color: #66b0ff;
}

.kbc-button-xs.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

.kbc-button-xs.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-success:after {
  border-color: #5dd879;
}

.kbc-button-xs.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-info:after {
  border-color: #4cd3e9;
}

.kbc-button-xs.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

.kbc-button-xs.kbc-button-warning:after {
  border-color: #a07800;
}

.kbc-button-xs.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-danger:after {
  border-color: #eb8c95;
}

.kbc-button-xs.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

.kbc-button-xs.kbc-button-light:after {
  border-color: #bdc6d0;
}

.kbc-button-xs.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

.kbc-button-xs.kbc-button-dark:after {
  border-color: #626d78;
}

.kbc-button-sm {
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0.25rem 0.25rem 0.4375rem;
  padding: 0.25rem 0.5rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

.kbc-button-sm:after {
  border-radius: 0.375rem;
  border-width: 0.09375rem;
  bottom: -7px;
  left: -0.25rem;
  right: -0.25rem;
  top: -1px;
  transform: translateZ(-3px);
  border-color: #ccc;
}

.kbc-button-sm.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-primary:after {
  border-color: #66b0ff;
}

.kbc-button-sm.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

.kbc-button-sm.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-success:after {
  border-color: #5dd879;
}

.kbc-button-sm.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-info:after {
  border-color: #4cd3e9;
}

.kbc-button-sm.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

.kbc-button-sm.kbc-button-warning:after {
  border-color: #a07800;
}

.kbc-button-sm.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-danger:after {
  border-color: #eb8c95;
}

.kbc-button-sm.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

.kbc-button-sm.kbc-button-light:after {
  border-color: #bdc6d0;
}

.kbc-button-sm.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

.kbc-button-sm.kbc-button-dark:after {
  border-color: #626d78;
}

.kbc-button-lg {
  font-size: 1.25rem;
  line-height: 1.5;
  margin: 0.25rem 0.25rem 0.75rem;
  padding: 0.5rem 1rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 0 6px #d9d9d9, 0 7px #d9d9d9, 0 8px #d9d9d9, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

.kbc-button-lg:after {
  border-radius: 0.5rem;
  border-width: 0.125rem;
  bottom: -13px;
  left: -0.375rem;
  right: -0.375rem;
  top: 3px;
  transform: translateZ(-8px);
  border-color: #ccc;
}

.kbc-button-lg.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 0 5px #4da3ff, 0 6px #4da3ff, 0 7px #4da3ff, 0 8px #4da3ff, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-primary:after {
  border-color: #66b0ff;
}

.kbc-button-lg.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 0 5px #939ba2, 0 6px #939ba2, 0 7px #939ba2, 0 8px #939ba2, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

.kbc-button-lg.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 0 5px #48d368, 0 6px #48d368, 0 7px #48d368, 0 8px #48d368, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-success:after {
  border-color: #5dd879;
}

.kbc-button-lg.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 0 5px #36cee6, 0 6px #36cee6, 0 7px #36cee6, 0 8px #36cee6, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-info:after {
  border-color: #4cd3e9;
}

.kbc-button-lg.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 0 5px #ba8b00, 0 6px #ba8b00, 0 7px #ba8b00, 0 8px #ba8b00, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

.kbc-button-lg.kbc-button-warning:after {
  border-color: #a07800;
}

.kbc-button-lg.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 0 5px #e77681, 0 6px #e77681, 0 7px #e77681, 0 8px #e77681, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-danger:after {
  border-color: #eb8c95;
}

.kbc-button-lg.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 0 5px #cbd3da, 0 6px #cbd3da, 0 7px #cbd3da, 0 8px #cbd3da, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

.kbc-button-lg.kbc-button-light:after {
  border-color: #bdc6d0;
}

.kbc-button-lg.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 0 5px #56606a, 0 6px #56606a, 0 7px #56606a, 0 8px #56606a, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

.kbc-button-lg.kbc-button-dark:after {
  border-color: #626d78;
}

.kbc-button.no-container:after {
  border-color: transparent;
}

.kbc-button:after {
  border-style: solid;
  box-sizing: content-box;
  content: "";
  display: block;
  position: absolute;
  transform-style: preserve-3d;
  transition: all 0.25s cubic-bezier(0.2, 1, 0.2, 1);
}

a.kbc-button, a.kbc-button:focus, a.kbc-button:hover {
  text-decoration: none;
}

a.kbc-button, button.kbc-button {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0.375rem 0.375rem 0.6875rem;
  padding: 0.375rem 0.75rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}

a.kbc-button.focus, a.kbc-button.hover, a.kbc-button:focus, a.kbc-button:hover, button.kbc-button.focus, button.kbc-button.hover, button.kbc-button:focus, button.kbc-button:hover {
  transform: translate3d(0, 1px, 5px);
}

a.kbc-button.focus:after, a.kbc-button.hover:after, a.kbc-button:focus:after, a.kbc-button:hover:after, button.kbc-button.focus:after, button.kbc-button.hover:after, button.kbc-button:focus:after, button.kbc-button:hover:after {
  transform: translate3d(0, -1px, -5px);
}

a.kbc-button.active, a.kbc-button:active, button.kbc-button.active, button.kbc-button:active {
  border-color: transparent;
  box-shadow: none;
  transform: translate3d(0, 5px, 0);
}

a.kbc-button.active:after, a.kbc-button:active:after, button.kbc-button.active:after, button.kbc-button:active:after {
  transform: translate3d(0, -5px, 0);
}

a.kbc-button:after, button.kbc-button:after {
  border-radius: 0.5rem;
  border-width: 0.125rem;
  bottom: -10px;
  left: -0.3125rem;
  right: -0.3125rem;
  top: 0;
  transform: translateZ(-5px);
}

a.kbc-button.focus, a.kbc-button.hover, a.kbc-button:focus, a.kbc-button:hover, button.kbc-button.focus, button.kbc-button.hover, button.kbc-button:focus, button.kbc-button:hover {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button.active, a.kbc-button:active, button.kbc-button.active, button.kbc-button:active {
  background-color: #e6e6e6;
  box-shadow: 0 0 1px 1px #b3b3b3;
  color: #343a40;
}

a.kbc-button:after, button.kbc-button:after {
  border-color: #ccc;
}

a.kbc-button-primary, button.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 0 5px #4da3ff, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-primary.focus, a.kbc-button-primary.hover, a.kbc-button-primary:focus, a.kbc-button-primary:hover, button.kbc-button-primary.focus, button.kbc-button-primary.hover, button.kbc-button-primary:focus, button.kbc-button-primary:hover {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-primary.active, a.kbc-button-primary:active, button.kbc-button-primary.active, button.kbc-button-primary:active {
  background-color: #3395ff;
  box-shadow: 0 0 1px 1px #99caff;
  color: #f8f9fa;
}

a.kbc-button-primary:after, button.kbc-button-primary:after {
  border-color: #66b0ff;
}

a.kbc-button-secondary, button.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 0 5px #939ba2, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-secondary.focus, a.kbc-button-secondary.hover, a.kbc-button-secondary:focus, a.kbc-button-secondary:hover, button.kbc-button-secondary.focus, button.kbc-button-secondary.hover, button.kbc-button-secondary:focus, button.kbc-button-secondary:hover {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-secondary.active, a.kbc-button-secondary:active, button.kbc-button-secondary.active, button.kbc-button-secondary:active {
  background-color: #868e96;
  box-shadow: 0 0 1px 1px #bcc1c6;
  color: #f8f9fa;
}

a.kbc-button-secondary:after, button.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

a.kbc-button-success, button.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 0 5px #48d368, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-success.focus, a.kbc-button-success.hover, a.kbc-button-success:focus, a.kbc-button-success:hover, button.kbc-button-success.focus, button.kbc-button-success.hover, button.kbc-button-success:focus, button.kbc-button-success:hover {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-success.active, a.kbc-button-success:active, button.kbc-button-success.active, button.kbc-button-success:active {
  background-color: #34ce57;
  box-shadow: 0 0 1px 1px #86e29b;
  color: #f8f9fa;
}

a.kbc-button-success:after, button.kbc-button-success:after {
  border-color: #5dd879;
}

a.kbc-button-info, button.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 0 5px #36cee6, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

a.kbc-button-info.focus, a.kbc-button-info.hover, a.kbc-button-info:focus, a.kbc-button-info:hover, button.kbc-button-info.focus, button.kbc-button-info.hover, button.kbc-button-info:focus, button.kbc-button-info:hover {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #1fc8e3;
  color: #343a40;
}

a.kbc-button-info.active, a.kbc-button-info:active, button.kbc-button-info.active, button.kbc-button-info:active {
  background-color: #1fc8e3;
  box-shadow: 0 0 1px 1px #7adeee;
  color: #343a40;
}

a.kbc-button-info:after, button.kbc-button-info:after {
  border-color: #4cd3e9;
}

a.kbc-button-warning, button.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 0 5px #ba8b00, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

a.kbc-button-warning.focus, a.kbc-button-warning.hover, a.kbc-button-warning:focus, a.kbc-button-warning:hover, button.kbc-button-warning.focus, button.kbc-button-warning.hover, button.kbc-button-warning:focus, button.kbc-button-warning:hover {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #d39e00;
  color: #343a40;
}

a.kbc-button-warning.active, a.kbc-button-warning:active, button.kbc-button-warning.active, button.kbc-button-warning:active {
  background-color: #d39e00;
  box-shadow: 0 0 1px 1px #6d5200;
  color: #343a40;
}

a.kbc-button-warning:after, button.kbc-button-warning:after {
  border-color: #a07800;
}

a.kbc-button-danger, button.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 0 5px #e77681, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-danger.focus, a.kbc-button-danger.hover, a.kbc-button-danger:focus, a.kbc-button-danger:hover, button.kbc-button-danger.focus, button.kbc-button-danger.hover, button.kbc-button-danger:focus, button.kbc-button-danger:hover {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-danger.active, a.kbc-button-danger:active, button.kbc-button-danger.active, button.kbc-button-danger:active {
  background-color: #e4606d;
  box-shadow: 0 0 1px 1px #f3b7bd;
  color: #f8f9fa;
}

a.kbc-button-danger:after, button.kbc-button-danger:after {
  border-color: #eb8c95;
}

a.kbc-button-light, button.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 0 5px #cbd3da, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-light.focus, a.kbc-button-light.hover, a.kbc-button-light:focus, a.kbc-button-light:hover, button.kbc-button-light.focus, button.kbc-button-light.hover, button.kbc-button-light:focus, button.kbc-button-light:hover {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-light.active, a.kbc-button-light:active, button.kbc-button-light.active, button.kbc-button-light:active {
  background-color: #dae0e5;
  box-shadow: 0 0 1px 1px #9fadba;
  color: #343a40;
}

a.kbc-button-light:after, button.kbc-button-light:after {
  border-color: #bdc6d0;
}

a.kbc-button-dark, button.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 0 5px #56606a, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-dark.focus, a.kbc-button-dark.hover, a.kbc-button-dark:focus, a.kbc-button-dark:hover, button.kbc-button-dark.focus, button.kbc-button-dark.hover, button.kbc-button-dark:focus, button.kbc-button-dark:hover {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 2px 2px 4px #adb5bd, 0 -1px 2px #adb5bd;
  background-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-dark.active, a.kbc-button-dark:active, button.kbc-button-dark.active, button.kbc-button-dark:active {
  background-color: #4b545c;
  box-shadow: 0 0 1px 1px #7a8793;
  color: #f8f9fa;
}

a.kbc-button-dark:after, button.kbc-button-dark:after {
  border-color: #626d78;
}

a.kbc-button-xxs, button.kbc-button-xxs {
  font-size: 0.7rem;
  line-height: 1.5;
  margin: 0.3125rem 0.3125rem 0.4375rem;
  padding: 0.1rem 0.3rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-xxs.focus, a.kbc-button-xxs.hover, a.kbc-button-xxs:focus, a.kbc-button-xxs:hover, button.kbc-button-xxs.focus, button.kbc-button-xxs.hover, button.kbc-button-xxs:focus, button.kbc-button-xxs:hover {
  transform: translate3d(0, 1px, 2px);
}

a.kbc-button-xxs.focus:after, a.kbc-button-xxs.hover:after, a.kbc-button-xxs:focus:after, a.kbc-button-xxs:hover:after, button.kbc-button-xxs.focus:after, button.kbc-button-xxs.hover:after, button.kbc-button-xxs:focus:after, button.kbc-button-xxs:hover:after {
  transform: translate3d(0, -1px, -2px);
}

a.kbc-button-xxs.active, a.kbc-button-xxs:active, button.kbc-button-xxs.active, button.kbc-button-xxs:active {
  border-color: transparent;
  box-shadow: none;
  transform: translate3d(0, 2px, 0);
}

a.kbc-button-xxs.active:after, a.kbc-button-xxs:active:after, button.kbc-button-xxs.active:after, button.kbc-button-xxs:active:after {
  transform: translate3d(0, -2px, 0);
}

a.kbc-button-xxs:after, button.kbc-button-xxs:after {
  border-radius: 0.375rem;
  border-width: 0.0625rem;
  bottom: -6px;
  left: -0.25rem;
  right: -0.25rem;
  top: -2px;
  transform: translateZ(-2px);
}

a.kbc-button-xxs.focus, a.kbc-button-xxs.hover, a.kbc-button-xxs:focus, a.kbc-button-xxs:hover, button.kbc-button-xxs.focus, button.kbc-button-xxs.hover, button.kbc-button-xxs:focus, button.kbc-button-xxs:hover {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-xxs.active, a.kbc-button-xxs:active, button.kbc-button-xxs.active, button.kbc-button-xxs:active {
  background-color: #e6e6e6;
  box-shadow: 0 0 1px 1px #b3b3b3;
  color: #343a40;
}

a.kbc-button-xxs:after, button.kbc-button-xxs:after {
  border-color: #ccc;
}

a.kbc-button-xxs.kbc-button-primary, button.kbc-button-xxs.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-primary.focus, a.kbc-button-xxs.kbc-button-primary.hover, a.kbc-button-xxs.kbc-button-primary:focus, a.kbc-button-xxs.kbc-button-primary:hover, button.kbc-button-xxs.kbc-button-primary.focus, button.kbc-button-xxs.kbc-button-primary.hover, button.kbc-button-xxs.kbc-button-primary:focus, button.kbc-button-xxs.kbc-button-primary:hover {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-primary.active, a.kbc-button-xxs.kbc-button-primary:active, button.kbc-button-xxs.kbc-button-primary.active, button.kbc-button-xxs.kbc-button-primary:active {
  background-color: #3395ff;
  box-shadow: 0 0 1px 1px #99caff;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-primary:after, button.kbc-button-xxs.kbc-button-primary:after {
  border-color: #66b0ff;
}

a.kbc-button-xxs.kbc-button-secondary, button.kbc-button-xxs.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-secondary.focus, a.kbc-button-xxs.kbc-button-secondary.hover, a.kbc-button-xxs.kbc-button-secondary:focus, a.kbc-button-xxs.kbc-button-secondary:hover, button.kbc-button-xxs.kbc-button-secondary.focus, button.kbc-button-xxs.kbc-button-secondary.hover, button.kbc-button-xxs.kbc-button-secondary:focus, button.kbc-button-xxs.kbc-button-secondary:hover {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-secondary.active, a.kbc-button-xxs.kbc-button-secondary:active, button.kbc-button-xxs.kbc-button-secondary.active, button.kbc-button-xxs.kbc-button-secondary:active {
  background-color: #868e96;
  box-shadow: 0 0 1px 1px #bcc1c6;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-secondary:after, button.kbc-button-xxs.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

a.kbc-button-xxs.kbc-button-success, button.kbc-button-xxs.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-success.focus, a.kbc-button-xxs.kbc-button-success.hover, a.kbc-button-xxs.kbc-button-success:focus, a.kbc-button-xxs.kbc-button-success:hover, button.kbc-button-xxs.kbc-button-success.focus, button.kbc-button-xxs.kbc-button-success.hover, button.kbc-button-xxs.kbc-button-success:focus, button.kbc-button-xxs.kbc-button-success:hover {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-success.active, a.kbc-button-xxs.kbc-button-success:active, button.kbc-button-xxs.kbc-button-success.active, button.kbc-button-xxs.kbc-button-success:active {
  background-color: #34ce57;
  box-shadow: 0 0 1px 1px #86e29b;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-success:after, button.kbc-button-xxs.kbc-button-success:after {
  border-color: #5dd879;
}

a.kbc-button-xxs.kbc-button-info, button.kbc-button-xxs.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-info.focus, a.kbc-button-xxs.kbc-button-info.hover, a.kbc-button-xxs.kbc-button-info:focus, a.kbc-button-xxs.kbc-button-info:hover, button.kbc-button-xxs.kbc-button-info.focus, button.kbc-button-xxs.kbc-button-info.hover, button.kbc-button-xxs.kbc-button-info:focus, button.kbc-button-xxs.kbc-button-info:hover {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #1fc8e3;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-info.active, a.kbc-button-xxs.kbc-button-info:active, button.kbc-button-xxs.kbc-button-info.active, button.kbc-button-xxs.kbc-button-info:active {
  background-color: #1fc8e3;
  box-shadow: 0 0 1px 1px #7adeee;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-info:after, button.kbc-button-xxs.kbc-button-info:after {
  border-color: #4cd3e9;
}

a.kbc-button-xxs.kbc-button-warning, button.kbc-button-xxs.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-warning.focus, a.kbc-button-xxs.kbc-button-warning.hover, a.kbc-button-xxs.kbc-button-warning:focus, a.kbc-button-xxs.kbc-button-warning:hover, button.kbc-button-xxs.kbc-button-warning.focus, button.kbc-button-xxs.kbc-button-warning.hover, button.kbc-button-xxs.kbc-button-warning:focus, button.kbc-button-xxs.kbc-button-warning:hover {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #d39e00;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-warning.active, a.kbc-button-xxs.kbc-button-warning:active, button.kbc-button-xxs.kbc-button-warning.active, button.kbc-button-xxs.kbc-button-warning:active {
  background-color: #d39e00;
  box-shadow: 0 0 1px 1px #6d5200;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-warning:after, button.kbc-button-xxs.kbc-button-warning:after {
  border-color: #a07800;
}

a.kbc-button-xxs.kbc-button-danger, button.kbc-button-xxs.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-danger.focus, a.kbc-button-xxs.kbc-button-danger.hover, a.kbc-button-xxs.kbc-button-danger:focus, a.kbc-button-xxs.kbc-button-danger:hover, button.kbc-button-xxs.kbc-button-danger.focus, button.kbc-button-xxs.kbc-button-danger.hover, button.kbc-button-xxs.kbc-button-danger:focus, button.kbc-button-xxs.kbc-button-danger:hover {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-danger.active, a.kbc-button-xxs.kbc-button-danger:active, button.kbc-button-xxs.kbc-button-danger.active, button.kbc-button-xxs.kbc-button-danger:active {
  background-color: #e4606d;
  box-shadow: 0 0 1px 1px #f3b7bd;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-danger:after, button.kbc-button-xxs.kbc-button-danger:after {
  border-color: #eb8c95;
}

a.kbc-button-xxs.kbc-button-light, button.kbc-button-xxs.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-light.focus, a.kbc-button-xxs.kbc-button-light.hover, a.kbc-button-xxs.kbc-button-light:focus, a.kbc-button-xxs.kbc-button-light:hover, button.kbc-button-xxs.kbc-button-light.focus, button.kbc-button-xxs.kbc-button-light.hover, button.kbc-button-xxs.kbc-button-light:focus, button.kbc-button-xxs.kbc-button-light:hover {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-light.active, a.kbc-button-xxs.kbc-button-light:active, button.kbc-button-xxs.kbc-button-light.active, button.kbc-button-xxs.kbc-button-light:active {
  background-color: #dae0e5;
  box-shadow: 0 0 1px 1px #9fadba;
  color: #343a40;
}

a.kbc-button-xxs.kbc-button-light:after, button.kbc-button-xxs.kbc-button-light:after {
  border-color: #bdc6d0;
}

a.kbc-button-xxs.kbc-button-dark, button.kbc-button-xxs.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-dark.focus, a.kbc-button-xxs.kbc-button-dark.hover, a.kbc-button-xxs.kbc-button-dark:focus, a.kbc-button-xxs.kbc-button-dark:hover, button.kbc-button-xxs.kbc-button-dark.focus, button.kbc-button-xxs.kbc-button-dark.hover, button.kbc-button-xxs.kbc-button-dark:focus, button.kbc-button-xxs.kbc-button-dark:hover {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-dark.active, a.kbc-button-xxs.kbc-button-dark:active, button.kbc-button-xxs.kbc-button-dark.active, button.kbc-button-xxs.kbc-button-dark:active {
  background-color: #4b545c;
  box-shadow: 0 0 1px 1px #7a8793;
  color: #f8f9fa;
}

a.kbc-button-xxs.kbc-button-dark:after, button.kbc-button-xxs.kbc-button-dark:after {
  border-color: #626d78;
}

a.kbc-button-xs, button.kbc-button-xs {
  font-size: 0.725rem;
  line-height: 1.5;
  margin: 0.3125rem 0.3125rem 0.4375rem;
  padding: 0.175rem 0.5rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-xs.focus, a.kbc-button-xs.hover, a.kbc-button-xs:focus, a.kbc-button-xs:hover, button.kbc-button-xs.focus, button.kbc-button-xs.hover, button.kbc-button-xs:focus, button.kbc-button-xs:hover {
  transform: translate3d(0, 1px, 2px);
}

a.kbc-button-xs.focus:after, a.kbc-button-xs.hover:after, a.kbc-button-xs:focus:after, a.kbc-button-xs:hover:after, button.kbc-button-xs.focus:after, button.kbc-button-xs.hover:after, button.kbc-button-xs:focus:after, button.kbc-button-xs:hover:after {
  transform: translate3d(0, -1px, -2px);
}

a.kbc-button-xs.active, a.kbc-button-xs:active, button.kbc-button-xs.active, button.kbc-button-xs:active {
  border-color: transparent;
  box-shadow: none;
  transform: translate3d(0, 2px, 0);
}

a.kbc-button-xs.active:after, a.kbc-button-xs:active:after, button.kbc-button-xs.active:after, button.kbc-button-xs:active:after {
  transform: translate3d(0, -2px, 0);
}

a.kbc-button-xs:after, button.kbc-button-xs:after {
  border-radius: 0.375rem;
  border-width: 0.0625rem;
  bottom: -6px;
  left: -0.25rem;
  right: -0.25rem;
  top: -2px;
  transform: translateZ(-2px);
}

a.kbc-button-xs.focus, a.kbc-button-xs.hover, a.kbc-button-xs:focus, a.kbc-button-xs:hover, button.kbc-button-xs.focus, button.kbc-button-xs.hover, button.kbc-button-xs:focus, button.kbc-button-xs:hover {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-xs.active, a.kbc-button-xs:active, button.kbc-button-xs.active, button.kbc-button-xs:active {
  background-color: #e6e6e6;
  box-shadow: 0 0 1px 1px #b3b3b3;
  color: #343a40;
}

a.kbc-button-xs:after, button.kbc-button-xs:after {
  border-color: #ccc;
}

a.kbc-button-xs.kbc-button-primary, button.kbc-button-xs.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-primary.focus, a.kbc-button-xs.kbc-button-primary.hover, a.kbc-button-xs.kbc-button-primary:focus, a.kbc-button-xs.kbc-button-primary:hover, button.kbc-button-xs.kbc-button-primary.focus, button.kbc-button-xs.kbc-button-primary.hover, button.kbc-button-xs.kbc-button-primary:focus, button.kbc-button-xs.kbc-button-primary:hover {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-primary.active, a.kbc-button-xs.kbc-button-primary:active, button.kbc-button-xs.kbc-button-primary.active, button.kbc-button-xs.kbc-button-primary:active {
  background-color: #3395ff;
  box-shadow: 0 0 1px 1px #99caff;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-primary:after, button.kbc-button-xs.kbc-button-primary:after {
  border-color: #66b0ff;
}

a.kbc-button-xs.kbc-button-secondary, button.kbc-button-xs.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-secondary.focus, a.kbc-button-xs.kbc-button-secondary.hover, a.kbc-button-xs.kbc-button-secondary:focus, a.kbc-button-xs.kbc-button-secondary:hover, button.kbc-button-xs.kbc-button-secondary.focus, button.kbc-button-xs.kbc-button-secondary.hover, button.kbc-button-xs.kbc-button-secondary:focus, button.kbc-button-xs.kbc-button-secondary:hover {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-secondary.active, a.kbc-button-xs.kbc-button-secondary:active, button.kbc-button-xs.kbc-button-secondary.active, button.kbc-button-xs.kbc-button-secondary:active {
  background-color: #868e96;
  box-shadow: 0 0 1px 1px #bcc1c6;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-secondary:after, button.kbc-button-xs.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

a.kbc-button-xs.kbc-button-success, button.kbc-button-xs.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-success.focus, a.kbc-button-xs.kbc-button-success.hover, a.kbc-button-xs.kbc-button-success:focus, a.kbc-button-xs.kbc-button-success:hover, button.kbc-button-xs.kbc-button-success.focus, button.kbc-button-xs.kbc-button-success.hover, button.kbc-button-xs.kbc-button-success:focus, button.kbc-button-xs.kbc-button-success:hover {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-success.active, a.kbc-button-xs.kbc-button-success:active, button.kbc-button-xs.kbc-button-success.active, button.kbc-button-xs.kbc-button-success:active {
  background-color: #34ce57;
  box-shadow: 0 0 1px 1px #86e29b;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-success:after, button.kbc-button-xs.kbc-button-success:after {
  border-color: #5dd879;
}

a.kbc-button-xs.kbc-button-info, button.kbc-button-xs.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-info.focus, a.kbc-button-xs.kbc-button-info.hover, a.kbc-button-xs.kbc-button-info:focus, a.kbc-button-xs.kbc-button-info:hover, button.kbc-button-xs.kbc-button-info.focus, button.kbc-button-xs.kbc-button-info.hover, button.kbc-button-xs.kbc-button-info:focus, button.kbc-button-xs.kbc-button-info:hover {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #1fc8e3;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-info.active, a.kbc-button-xs.kbc-button-info:active, button.kbc-button-xs.kbc-button-info.active, button.kbc-button-xs.kbc-button-info:active {
  background-color: #1fc8e3;
  box-shadow: 0 0 1px 1px #7adeee;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-info:after, button.kbc-button-xs.kbc-button-info:after {
  border-color: #4cd3e9;
}

a.kbc-button-xs.kbc-button-warning, button.kbc-button-xs.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-warning.focus, a.kbc-button-xs.kbc-button-warning.hover, a.kbc-button-xs.kbc-button-warning:focus, a.kbc-button-xs.kbc-button-warning:hover, button.kbc-button-xs.kbc-button-warning.focus, button.kbc-button-xs.kbc-button-warning.hover, button.kbc-button-xs.kbc-button-warning:focus, button.kbc-button-xs.kbc-button-warning:hover {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #d39e00;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-warning.active, a.kbc-button-xs.kbc-button-warning:active, button.kbc-button-xs.kbc-button-warning.active, button.kbc-button-xs.kbc-button-warning:active {
  background-color: #d39e00;
  box-shadow: 0 0 1px 1px #6d5200;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-warning:after, button.kbc-button-xs.kbc-button-warning:after {
  border-color: #a07800;
}

a.kbc-button-xs.kbc-button-danger, button.kbc-button-xs.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-danger.focus, a.kbc-button-xs.kbc-button-danger.hover, a.kbc-button-xs.kbc-button-danger:focus, a.kbc-button-xs.kbc-button-danger:hover, button.kbc-button-xs.kbc-button-danger.focus, button.kbc-button-xs.kbc-button-danger.hover, button.kbc-button-xs.kbc-button-danger:focus, button.kbc-button-xs.kbc-button-danger:hover {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-danger.active, a.kbc-button-xs.kbc-button-danger:active, button.kbc-button-xs.kbc-button-danger.active, button.kbc-button-xs.kbc-button-danger:active {
  background-color: #e4606d;
  box-shadow: 0 0 1px 1px #f3b7bd;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-danger:after, button.kbc-button-xs.kbc-button-danger:after {
  border-color: #eb8c95;
}

a.kbc-button-xs.kbc-button-light, button.kbc-button-xs.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-light.focus, a.kbc-button-xs.kbc-button-light.hover, a.kbc-button-xs.kbc-button-light:focus, a.kbc-button-xs.kbc-button-light:hover, button.kbc-button-xs.kbc-button-light.focus, button.kbc-button-xs.kbc-button-light.hover, button.kbc-button-xs.kbc-button-light:focus, button.kbc-button-xs.kbc-button-light:hover {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-light.active, a.kbc-button-xs.kbc-button-light:active, button.kbc-button-xs.kbc-button-light.active, button.kbc-button-xs.kbc-button-light:active {
  background-color: #dae0e5;
  box-shadow: 0 0 1px 1px #9fadba;
  color: #343a40;
}

a.kbc-button-xs.kbc-button-light:after, button.kbc-button-xs.kbc-button-light:after {
  border-color: #bdc6d0;
}

a.kbc-button-xs.kbc-button-dark, button.kbc-button-xs.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-dark.focus, a.kbc-button-xs.kbc-button-dark.hover, a.kbc-button-xs.kbc-button-dark:focus, a.kbc-button-xs.kbc-button-dark:hover, button.kbc-button-xs.kbc-button-dark.focus, button.kbc-button-xs.kbc-button-dark.hover, button.kbc-button-xs.kbc-button-dark:focus, button.kbc-button-xs.kbc-button-dark:hover {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 2px 0.5px 4px #adb5bd, 0 -1px 0.5px #adb5bd;
  background-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-dark.active, a.kbc-button-xs.kbc-button-dark:active, button.kbc-button-xs.kbc-button-dark.active, button.kbc-button-xs.kbc-button-dark:active {
  background-color: #4b545c;
  box-shadow: 0 0 1px 1px #7a8793;
  color: #f8f9fa;
}

a.kbc-button-xs.kbc-button-dark:after, button.kbc-button-xs.kbc-button-dark:after {
  border-color: #626d78;
}

a.kbc-button-sm, button.kbc-button-sm {
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0.34375rem 0.34375rem 0.53125rem;
  padding: 0.25rem 0.5rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-sm.focus, a.kbc-button-sm.hover, a.kbc-button-sm:focus, a.kbc-button-sm:hover, button.kbc-button-sm.focus, button.kbc-button-sm.hover, button.kbc-button-sm:focus, button.kbc-button-sm:hover {
  transform: translate3d(0, 1px, 3px);
}

a.kbc-button-sm.focus:after, a.kbc-button-sm.hover:after, a.kbc-button-sm:focus:after, a.kbc-button-sm:hover:after, button.kbc-button-sm.focus:after, button.kbc-button-sm.hover:after, button.kbc-button-sm:focus:after, button.kbc-button-sm:hover:after {
  transform: translate3d(0, -1px, -3px);
}

a.kbc-button-sm.active, a.kbc-button-sm:active, button.kbc-button-sm.active, button.kbc-button-sm:active {
  border-color: transparent;
  box-shadow: none;
  transform: translate3d(0, 3px, 0);
}

a.kbc-button-sm.active:after, a.kbc-button-sm:active:after, button.kbc-button-sm.active:after, button.kbc-button-sm:active:after {
  transform: translate3d(0, -3px, 0);
}

a.kbc-button-sm:after, button.kbc-button-sm:after {
  border-radius: 0.375rem;
  border-width: 0.09375rem;
  bottom: -7px;
  left: -0.25rem;
  right: -0.25rem;
  top: -1px;
  transform: translateZ(-3px);
}

a.kbc-button-sm.focus, a.kbc-button-sm.hover, a.kbc-button-sm:focus, a.kbc-button-sm:hover, button.kbc-button-sm.focus, button.kbc-button-sm.hover, button.kbc-button-sm:focus, button.kbc-button-sm:hover {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-sm.active, a.kbc-button-sm:active, button.kbc-button-sm.active, button.kbc-button-sm:active {
  background-color: #e6e6e6;
  box-shadow: 0 0 1px 1px #b3b3b3;
  color: #343a40;
}

a.kbc-button-sm:after, button.kbc-button-sm:after {
  border-color: #ccc;
}

a.kbc-button-sm.kbc-button-primary, button.kbc-button-sm.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-primary.focus, a.kbc-button-sm.kbc-button-primary.hover, a.kbc-button-sm.kbc-button-primary:focus, a.kbc-button-sm.kbc-button-primary:hover, button.kbc-button-sm.kbc-button-primary.focus, button.kbc-button-sm.kbc-button-primary.hover, button.kbc-button-sm.kbc-button-primary:focus, button.kbc-button-sm.kbc-button-primary:hover {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-primary.active, a.kbc-button-sm.kbc-button-primary:active, button.kbc-button-sm.kbc-button-primary.active, button.kbc-button-sm.kbc-button-primary:active {
  background-color: #3395ff;
  box-shadow: 0 0 1px 1px #99caff;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-primary:after, button.kbc-button-sm.kbc-button-primary:after {
  border-color: #66b0ff;
}

a.kbc-button-sm.kbc-button-secondary, button.kbc-button-sm.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-secondary.focus, a.kbc-button-sm.kbc-button-secondary.hover, a.kbc-button-sm.kbc-button-secondary:focus, a.kbc-button-sm.kbc-button-secondary:hover, button.kbc-button-sm.kbc-button-secondary.focus, button.kbc-button-sm.kbc-button-secondary.hover, button.kbc-button-sm.kbc-button-secondary:focus, button.kbc-button-sm.kbc-button-secondary:hover {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-secondary.active, a.kbc-button-sm.kbc-button-secondary:active, button.kbc-button-sm.kbc-button-secondary.active, button.kbc-button-sm.kbc-button-secondary:active {
  background-color: #868e96;
  box-shadow: 0 0 1px 1px #bcc1c6;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-secondary:after, button.kbc-button-sm.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

a.kbc-button-sm.kbc-button-success, button.kbc-button-sm.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-success.focus, a.kbc-button-sm.kbc-button-success.hover, a.kbc-button-sm.kbc-button-success:focus, a.kbc-button-sm.kbc-button-success:hover, button.kbc-button-sm.kbc-button-success.focus, button.kbc-button-sm.kbc-button-success.hover, button.kbc-button-sm.kbc-button-success:focus, button.kbc-button-sm.kbc-button-success:hover {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-success.active, a.kbc-button-sm.kbc-button-success:active, button.kbc-button-sm.kbc-button-success.active, button.kbc-button-sm.kbc-button-success:active {
  background-color: #34ce57;
  box-shadow: 0 0 1px 1px #86e29b;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-success:after, button.kbc-button-sm.kbc-button-success:after {
  border-color: #5dd879;
}

a.kbc-button-sm.kbc-button-info, button.kbc-button-sm.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-info.focus, a.kbc-button-sm.kbc-button-info.hover, a.kbc-button-sm.kbc-button-info:focus, a.kbc-button-sm.kbc-button-info:hover, button.kbc-button-sm.kbc-button-info.focus, button.kbc-button-sm.kbc-button-info.hover, button.kbc-button-sm.kbc-button-info:focus, button.kbc-button-sm.kbc-button-info:hover {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #1fc8e3;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-info.active, a.kbc-button-sm.kbc-button-info:active, button.kbc-button-sm.kbc-button-info.active, button.kbc-button-sm.kbc-button-info:active {
  background-color: #1fc8e3;
  box-shadow: 0 0 1px 1px #7adeee;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-info:after, button.kbc-button-sm.kbc-button-info:after {
  border-color: #4cd3e9;
}

a.kbc-button-sm.kbc-button-warning, button.kbc-button-sm.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-warning.focus, a.kbc-button-sm.kbc-button-warning.hover, a.kbc-button-sm.kbc-button-warning:focus, a.kbc-button-sm.kbc-button-warning:hover, button.kbc-button-sm.kbc-button-warning.focus, button.kbc-button-sm.kbc-button-warning.hover, button.kbc-button-sm.kbc-button-warning:focus, button.kbc-button-sm.kbc-button-warning:hover {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #d39e00;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-warning.active, a.kbc-button-sm.kbc-button-warning:active, button.kbc-button-sm.kbc-button-warning.active, button.kbc-button-sm.kbc-button-warning:active {
  background-color: #d39e00;
  box-shadow: 0 0 1px 1px #6d5200;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-warning:after, button.kbc-button-sm.kbc-button-warning:after {
  border-color: #a07800;
}

a.kbc-button-sm.kbc-button-danger, button.kbc-button-sm.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-danger.focus, a.kbc-button-sm.kbc-button-danger.hover, a.kbc-button-sm.kbc-button-danger:focus, a.kbc-button-sm.kbc-button-danger:hover, button.kbc-button-sm.kbc-button-danger.focus, button.kbc-button-sm.kbc-button-danger.hover, button.kbc-button-sm.kbc-button-danger:focus, button.kbc-button-sm.kbc-button-danger:hover {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-danger.active, a.kbc-button-sm.kbc-button-danger:active, button.kbc-button-sm.kbc-button-danger.active, button.kbc-button-sm.kbc-button-danger:active {
  background-color: #e4606d;
  box-shadow: 0 0 1px 1px #f3b7bd;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-danger:after, button.kbc-button-sm.kbc-button-danger:after {
  border-color: #eb8c95;
}

a.kbc-button-sm.kbc-button-light, button.kbc-button-sm.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-light.focus, a.kbc-button-sm.kbc-button-light.hover, a.kbc-button-sm.kbc-button-light:focus, a.kbc-button-sm.kbc-button-light:hover, button.kbc-button-sm.kbc-button-light.focus, button.kbc-button-sm.kbc-button-light.hover, button.kbc-button-sm.kbc-button-light:focus, button.kbc-button-sm.kbc-button-light:hover {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-light.active, a.kbc-button-sm.kbc-button-light:active, button.kbc-button-sm.kbc-button-light.active, button.kbc-button-sm.kbc-button-light:active {
  background-color: #dae0e5;
  box-shadow: 0 0 1px 1px #9fadba;
  color: #343a40;
}

a.kbc-button-sm.kbc-button-light:after, button.kbc-button-sm.kbc-button-light:after {
  border-color: #bdc6d0;
}

a.kbc-button-sm.kbc-button-dark, button.kbc-button-sm.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 2px 1.5px 4px #adb5bd, 0 -1px 1.5px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-dark.focus, a.kbc-button-sm.kbc-button-dark.hover, a.kbc-button-sm.kbc-button-dark:focus, a.kbc-button-sm.kbc-button-dark:hover, button.kbc-button-sm.kbc-button-dark.focus, button.kbc-button-sm.kbc-button-dark.hover, button.kbc-button-sm.kbc-button-dark:focus, button.kbc-button-sm.kbc-button-dark:hover {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
  background-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-dark.active, a.kbc-button-sm.kbc-button-dark:active, button.kbc-button-sm.kbc-button-dark.active, button.kbc-button-sm.kbc-button-dark:active {
  background-color: #4b545c;
  box-shadow: 0 0 1px 1px #7a8793;
  color: #f8f9fa;
}

a.kbc-button-sm.kbc-button-dark:after, button.kbc-button-sm.kbc-button-dark:after {
  border-color: #626d78;
}

a.kbc-button-lg, button.kbc-button-lg {
  font-size: 1.25rem;
  line-height: 1.5;
  margin: 0.375rem 0.375rem 0.875rem;
  padding: 0.5rem 1rem;
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 0 6px #d9d9d9, 0 7px #d9d9d9, 0 8px #d9d9d9, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #fff;
  border-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-lg.focus, a.kbc-button-lg.hover, a.kbc-button-lg:focus, a.kbc-button-lg:hover, button.kbc-button-lg.focus, button.kbc-button-lg.hover, button.kbc-button-lg:focus, button.kbc-button-lg:hover {
  transform: translate3d(0, 1px, 8px);
}

a.kbc-button-lg.focus:after, a.kbc-button-lg.hover:after, a.kbc-button-lg:focus:after, a.kbc-button-lg:hover:after, button.kbc-button-lg.focus:after, button.kbc-button-lg.hover:after, button.kbc-button-lg:focus:after, button.kbc-button-lg:hover:after {
  transform: translate3d(0, -1px, -8px);
}

a.kbc-button-lg.active, a.kbc-button-lg:active, button.kbc-button-lg.active, button.kbc-button-lg:active {
  border-color: transparent;
  box-shadow: none;
  transform: translate3d(0, 8px, 0);
}

a.kbc-button-lg.active:after, a.kbc-button-lg:active:after, button.kbc-button-lg.active:after, button.kbc-button-lg:active:after {
  transform: translate3d(0, -8px, 0);
}

a.kbc-button-lg:after, button.kbc-button-lg:after {
  border-radius: 0.5rem;
  border-width: 0.125rem;
  bottom: -13px;
  left: -0.375rem;
  right: -0.375rem;
  top: 3px;
  transform: translateZ(-8px);
}

a.kbc-button-lg.focus, a.kbc-button-lg.hover, a.kbc-button-lg:focus, a.kbc-button-lg:hover, button.kbc-button-lg.focus, button.kbc-button-lg.hover, button.kbc-button-lg:focus, button.kbc-button-lg:hover {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 0 6px #d9d9d9, 0 7px #d9d9d9, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #e6e6e6;
  color: #343a40;
}

a.kbc-button-lg.active, a.kbc-button-lg:active, button.kbc-button-lg.active, button.kbc-button-lg:active {
  background-color: #e6e6e6;
  box-shadow: 0 0 1px 1px #b3b3b3;
  color: #343a40;
}

a.kbc-button-lg:after, button.kbc-button-lg:after {
  border-color: #ccc;
}

a.kbc-button-lg.kbc-button-primary, button.kbc-button-lg.kbc-button-primary {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 0 5px #4da3ff, 0 6px #4da3ff, 0 7px #4da3ff, 0 8px #4da3ff, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #007bff;
  border-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-primary.focus, a.kbc-button-lg.kbc-button-primary.hover, a.kbc-button-lg.kbc-button-primary:focus, a.kbc-button-lg.kbc-button-primary:hover, button.kbc-button-lg.kbc-button-primary.focus, button.kbc-button-lg.kbc-button-primary.hover, button.kbc-button-lg.kbc-button-primary:focus, button.kbc-button-lg.kbc-button-primary:hover {
  box-shadow: 0 0 #4da3ff, 0 0 #4da3ff, 0 1px #4da3ff, 0 2px #4da3ff, 0 3px #4da3ff, 0 4px #4da3ff, 0 5px #4da3ff, 0 6px #4da3ff, 0 7px #4da3ff, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #3395ff;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-primary.active, a.kbc-button-lg.kbc-button-primary:active, button.kbc-button-lg.kbc-button-primary.active, button.kbc-button-lg.kbc-button-primary:active {
  background-color: #3395ff;
  box-shadow: 0 0 1px 1px #99caff;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-primary:after, button.kbc-button-lg.kbc-button-primary:after {
  border-color: #66b0ff;
}

a.kbc-button-lg.kbc-button-secondary, button.kbc-button-lg.kbc-button-secondary {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 0 5px #939ba2, 0 6px #939ba2, 0 7px #939ba2, 0 8px #939ba2, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #6c757d;
  border-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-secondary.focus, a.kbc-button-lg.kbc-button-secondary.hover, a.kbc-button-lg.kbc-button-secondary:focus, a.kbc-button-lg.kbc-button-secondary:hover, button.kbc-button-lg.kbc-button-secondary.focus, button.kbc-button-lg.kbc-button-secondary.hover, button.kbc-button-lg.kbc-button-secondary:focus, button.kbc-button-lg.kbc-button-secondary:hover {
  box-shadow: 0 0 #939ba2, 0 0 #939ba2, 0 1px #939ba2, 0 2px #939ba2, 0 3px #939ba2, 0 4px #939ba2, 0 5px #939ba2, 0 6px #939ba2, 0 7px #939ba2, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #868e96;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-secondary.active, a.kbc-button-lg.kbc-button-secondary:active, button.kbc-button-lg.kbc-button-secondary.active, button.kbc-button-lg.kbc-button-secondary:active {
  background-color: #868e96;
  box-shadow: 0 0 1px 1px #bcc1c6;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-secondary:after, button.kbc-button-lg.kbc-button-secondary:after {
  border-color: #a1a8ae;
}

a.kbc-button-lg.kbc-button-success, button.kbc-button-lg.kbc-button-success {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 0 5px #48d368, 0 6px #48d368, 0 7px #48d368, 0 8px #48d368, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #28a745;
  border-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-success.focus, a.kbc-button-lg.kbc-button-success.hover, a.kbc-button-lg.kbc-button-success:focus, a.kbc-button-lg.kbc-button-success:hover, button.kbc-button-lg.kbc-button-success.focus, button.kbc-button-lg.kbc-button-success.hover, button.kbc-button-lg.kbc-button-success:focus, button.kbc-button-lg.kbc-button-success:hover {
  box-shadow: 0 0 #48d368, 0 0 #48d368, 0 1px #48d368, 0 2px #48d368, 0 3px #48d368, 0 4px #48d368, 0 5px #48d368, 0 6px #48d368, 0 7px #48d368, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #34ce57;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-success.active, a.kbc-button-lg.kbc-button-success:active, button.kbc-button-lg.kbc-button-success.active, button.kbc-button-lg.kbc-button-success:active {
  background-color: #34ce57;
  box-shadow: 0 0 1px 1px #86e29b;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-success:after, button.kbc-button-lg.kbc-button-success:after {
  border-color: #5dd879;
}

a.kbc-button-lg.kbc-button-info, button.kbc-button-lg.kbc-button-info {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 0 5px #36cee6, 0 6px #36cee6, 0 7px #36cee6, 0 8px #36cee6, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #17a2b8;
  border-color: #1fc8e3;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-info.focus, a.kbc-button-lg.kbc-button-info.hover, a.kbc-button-lg.kbc-button-info:focus, a.kbc-button-lg.kbc-button-info:hover, button.kbc-button-lg.kbc-button-info.focus, button.kbc-button-lg.kbc-button-info.hover, button.kbc-button-lg.kbc-button-info:focus, button.kbc-button-lg.kbc-button-info:hover {
  box-shadow: 0 0 #36cee6, 0 0 #36cee6, 0 1px #36cee6, 0 2px #36cee6, 0 3px #36cee6, 0 4px #36cee6, 0 5px #36cee6, 0 6px #36cee6, 0 7px #36cee6, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #1fc8e3;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-info.active, a.kbc-button-lg.kbc-button-info:active, button.kbc-button-lg.kbc-button-info.active, button.kbc-button-lg.kbc-button-info:active {
  background-color: #1fc8e3;
  box-shadow: 0 0 1px 1px #7adeee;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-info:after, button.kbc-button-lg.kbc-button-info:after {
  border-color: #4cd3e9;
}

a.kbc-button-lg.kbc-button-warning, button.kbc-button-lg.kbc-button-warning {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 0 5px #ba8b00, 0 6px #ba8b00, 0 7px #ba8b00, 0 8px #ba8b00, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #ffc107;
  border-color: #d39e00;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-warning.focus, a.kbc-button-lg.kbc-button-warning.hover, a.kbc-button-lg.kbc-button-warning:focus, a.kbc-button-lg.kbc-button-warning:hover, button.kbc-button-lg.kbc-button-warning.focus, button.kbc-button-lg.kbc-button-warning.hover, button.kbc-button-lg.kbc-button-warning:focus, button.kbc-button-lg.kbc-button-warning:hover {
  box-shadow: 0 0 #ba8b00, 0 0 #ba8b00, 0 1px #ba8b00, 0 2px #ba8b00, 0 3px #ba8b00, 0 4px #ba8b00, 0 5px #ba8b00, 0 6px #ba8b00, 0 7px #ba8b00, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #d39e00;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-warning.active, a.kbc-button-lg.kbc-button-warning:active, button.kbc-button-lg.kbc-button-warning.active, button.kbc-button-lg.kbc-button-warning:active {
  background-color: #d39e00;
  box-shadow: 0 0 1px 1px #6d5200;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-warning:after, button.kbc-button-lg.kbc-button-warning:after {
  border-color: #a07800;
}

a.kbc-button-lg.kbc-button-danger, button.kbc-button-lg.kbc-button-danger {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 0 5px #e77681, 0 6px #e77681, 0 7px #e77681, 0 8px #e77681, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #dc3545;
  border-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-danger.focus, a.kbc-button-lg.kbc-button-danger.hover, a.kbc-button-lg.kbc-button-danger:focus, a.kbc-button-lg.kbc-button-danger:hover, button.kbc-button-lg.kbc-button-danger.focus, button.kbc-button-lg.kbc-button-danger.hover, button.kbc-button-lg.kbc-button-danger:focus, button.kbc-button-lg.kbc-button-danger:hover {
  box-shadow: 0 0 #e77681, 0 0 #e77681, 0 1px #e77681, 0 2px #e77681, 0 3px #e77681, 0 4px #e77681, 0 5px #e77681, 0 6px #e77681, 0 7px #e77681, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #e4606d;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-danger.active, a.kbc-button-lg.kbc-button-danger:active, button.kbc-button-lg.kbc-button-danger.active, button.kbc-button-lg.kbc-button-danger:active {
  background-color: #e4606d;
  box-shadow: 0 0 1px 1px #f3b7bd;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-danger:after, button.kbc-button-lg.kbc-button-danger:after {
  border-color: #eb8c95;
}

a.kbc-button-lg.kbc-button-light, button.kbc-button-lg.kbc-button-light {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 0 5px #cbd3da, 0 6px #cbd3da, 0 7px #cbd3da, 0 8px #cbd3da, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #f8f9fa;
  border-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-light.focus, a.kbc-button-lg.kbc-button-light.hover, a.kbc-button-lg.kbc-button-light:focus, a.kbc-button-lg.kbc-button-light:hover, button.kbc-button-lg.kbc-button-light.focus, button.kbc-button-lg.kbc-button-light.hover, button.kbc-button-lg.kbc-button-light:focus, button.kbc-button-lg.kbc-button-light:hover {
  box-shadow: 0 0 #cbd3da, 0 0 #cbd3da, 0 1px #cbd3da, 0 2px #cbd3da, 0 3px #cbd3da, 0 4px #cbd3da, 0 5px #cbd3da, 0 6px #cbd3da, 0 7px #cbd3da, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #dae0e5;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-light.active, a.kbc-button-lg.kbc-button-light:active, button.kbc-button-lg.kbc-button-light.active, button.kbc-button-lg.kbc-button-light:active {
  background-color: #dae0e5;
  box-shadow: 0 0 1px 1px #9fadba;
  color: #343a40;
}

a.kbc-button-lg.kbc-button-light:after, button.kbc-button-lg.kbc-button-light:after {
  border-color: #bdc6d0;
}

a.kbc-button-lg.kbc-button-dark, button.kbc-button-lg.kbc-button-dark {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 0 5px #56606a, 0 6px #56606a, 0 7px #56606a, 0 8px #56606a, 2px 4px 4px #adb5bd, 0 -1px 4px #adb5bd;
  background-color: #343a40;
  border-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-dark.focus, a.kbc-button-lg.kbc-button-dark.hover, a.kbc-button-lg.kbc-button-dark:focus, a.kbc-button-lg.kbc-button-dark:hover, button.kbc-button-lg.kbc-button-dark.focus, button.kbc-button-lg.kbc-button-dark.hover, button.kbc-button-lg.kbc-button-dark:focus, button.kbc-button-lg.kbc-button-dark:hover {
  box-shadow: 0 0 #56606a, 0 0 #56606a, 0 1px #56606a, 0 2px #56606a, 0 3px #56606a, 0 4px #56606a, 0 5px #56606a, 0 6px #56606a, 0 7px #56606a, 2px 3.5px 4px #adb5bd, 0 -1px 3.5px #adb5bd;
  background-color: #4b545c;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-dark.active, a.kbc-button-lg.kbc-button-dark:active, button.kbc-button-lg.kbc-button-dark.active, button.kbc-button-lg.kbc-button-dark:active {
  background-color: #4b545c;
  box-shadow: 0 0 1px 1px #7a8793;
  color: #f8f9fa;
}

a.kbc-button-lg.kbc-button-dark:after, button.kbc-button-lg.kbc-button-dark:after {
  border-color: #626d78;
}

a.kbc-button.disabled, a.kbc-button:disabled, button.kbc-button.disabled, button.kbc-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
  pointer-events: none;
}

a.kbc-button.focus, a.kbc-button.hover, a.kbc-button:focus, a.kbc-button:hover, button.kbc-button.focus, button.kbc-button.hover, button.kbc-button:focus, button.kbc-button:hover {
  outline: none;
}

a.kbc-button, button.kbc-button {
  padding: 0.1rem 0.25rem;
}
a.kbc-button.kbc-button-small, button.kbc-button.kbc-button-small {
  padding: 0.05rem 0.15rem;
  font-size: 0.7rem;
}
a.kbc-button.no-click, button.kbc-button.no-click {
  cursor: default;
}
a.kbc-button.no-click:hover, a.kbc-button.no-click:focus, a.kbc-button.no-click.hover, a.kbc-button.no-click.focus, button.kbc-button.no-click:hover, button.kbc-button.no-click:focus, button.kbc-button.no-click.hover, button.kbc-button.no-click.focus {
  box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
  background-color: #fff;
  color: #343a40;
  border-color: #e6e6e6;
  transform: translateZ(5px);
}
a.kbc-button.no-click:hover:after, a.kbc-button.no-click:focus:after, a.kbc-button.no-click.hover:after, a.kbc-button.no-click.focus:after, button.kbc-button.no-click:hover:after, button.kbc-button.no-click:focus:after, button.kbc-button.no-click.hover:after, button.kbc-button.no-click.focus:after {
  transform: translateZ(-5px);
}`;
const shadowOptions = { "mode": "open" };
let KeyboardKeyComponent = class KeyboardKeyComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.small = false;
        this.noclick = false;
    }
};
exports.KeyboardKeyComponent = KeyboardKeyComponent;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KeyboardKeyComponent.prototype, "small", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KeyboardKeyComponent.prototype, "noclick", void 0);
exports.KeyboardKeyComponent = KeyboardKeyComponent = __decorate([
    (0, client_1.RWSView)('kbd-key', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], KeyboardKeyComponent);
KeyboardKeyComponent.defineComponent();
